import * as yup from 'yup'

const schema = () =>
  yup.object().shape({
    simplifiedForm: yup.string().required('Selecione o formato do relatório'),
  })

export default schema
